import { render, staticRenderFns } from "./PersonWrapper.vue?vue&type=template&id=368ee8a0"
import script from "./PersonWrapper.vue?vue&type=script&lang=js"
export * from "./PersonWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports